export const environment: any = {
  production: false,
  'ZONEIQ_AUTH_SERVICE': 'https://zapi-auth.gridics.com',
  'TASK_TAB': 'true',
  'ACCOUNT_SUBSCRIPTIONS': 'http://accounts.gridics.com/my/subscriptions',
  'ALLOW_SYNC_SOLR_AU_DATA': 'true',
  'ZONAR_API_URL': 'https://zapi.gridics.com/api/v3',
  'SHOW_SYNC_SOLR_AU_DATA_CHECKBOX': 'true'
};
